import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PromotionResponse, PromotionService } from 'promotion-shared';

@Injectable({
  providedIn: 'root',
})
export class EshopPromotionService extends PromotionService {
  protected getPromotionByCode(code: string) {
    return this.api.public.getPromotionByCode(code);
  }

  public getPCPromotionByCode(code: string): Observable<{ promotions: PromotionResponse[] } | { error: string }> {
    return this.observableDataLoader.get('PC_promo' + code, () => this.getPromotionByCode(code));
  }
}
